export const category = `
  id
  name
  slug
`

export const post = `
  id
  databaseId
  content
  contentJson: content
  created: date
  publicationDate: date
  slug
  title
  excerpt
  author {
    node {
      id
      name
      firstName
      lastName
      avatar {
        url
      }
    }
  }
  featuredImage {
    node {
      blogSmall: sourceUrl(size: BLOG_SMALL)
      blogBig: sourceUrl(size: BLOG_BIG)
      blogPost: sourceUrl(size: BLOG_POST)
      thumbnail: sourceUrl(size: MEDIUM)
      thumbnail2x: sourceUrl(size: LARGE)
      bigMobile: sourceUrl(size: LARGE)
      srcSet
    }
  }
  categories(first: 1000) {
    nodes {
      ${category}
      parent {
        node {
          ${category}
        }
      }
    }
  }
  configPosts {
    lastUpdate
  }
  tags {
    nodes {
      id
      name
      slug
    }
  }
  comments(first: 1000) {
    nodes {
      date
      content
      databaseId
      parentDatabaseId

      author {
        node {
          name
        }
      }
    }
  }
`;
